import { render, staticRenderFns } from "./Recibo.vue?vue&type=template&id=24e81e3c&scoped=true&"
import script from "./Recibo.vue?vue&type=script&lang=js&"
export * from "./Recibo.vue?vue&type=script&lang=js&"
import style0 from "./Recibo.vue?vue&type=style&index=0&id=24e81e3c&lang=scss&scoped=true&"
import style1 from "./Recibo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e81e3c",
  null
  
)

export default component.exports